import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Cropper from "react-easy-crop";

const ImageCropDialog = ({ open, image, onDone }) => {

    const [crop, setCrop] = useState({x: 0, y: 0});
    const [zoom, setZoom] = useState(1);
    const [croppedArea, setCroppedArea] = useState(null);

    const onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
        setCroppedArea(croppedAreaPixels);
    }

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>Выберите нужную часть картинки, используя мышь</DialogTitle>
            <DialogContent
                dividers
                sx={{aspectRatio: "2 / 1"}}
                >
                <Cropper
                    image={image}
                    aspect={1}
                    crop={crop}
                    zoom={zoom}
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={onCropComplete}
                    style={{
                        containerStyle: {
                            position: "relative",
                            width: "100%",
                            height: "100%",
                        },
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={() => onDone(true, croppedArea)}>Применить</Button>
                <Button variant="contained" onClick={() => onDone(false)}>Отмена</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImageCropDialog;